import React from 'react';

/**
 * BusinessPlaceholder - Widget placeholder pour sections métier
 *
 * Utilisé pour les rôles dont les widgets métier ne sont pas encore définis.
 * Ex: Comptabilité, Administrative
 */
const BusinessPlaceholder = ({ role, items = [], onNavigate }) => {
  const roleConfigs = {
    'Comptabilité': {
      icon: '📊',
      title: 'Espace Comptabilité',
      description: 'Suivi des heures et facturation',
      items: [
        { label: 'Heures à facturer', status: 'À venir', icon: '⏱️' },
        { label: 'Prestations terminées non facturées', status: 'À venir', icon: '📋' },
        { label: 'Comparatif heures prévues/réalisées', status: 'À venir', icon: '📈' }
      ],
      navLink: 'planning',
      navLabel: 'Voir planning'
    },
    'Administrative': {
      icon: '📁',
      title: 'Espace Administratif',
      description: 'Gestion documentaire et suivi',
      items: [
        { label: 'Documents en attente', status: 'À venir', icon: '📄' },
        { label: 'Factures à traiter', status: 'À venir', icon: '💶' },
        { label: 'Suivi administratif', status: 'À venir', icon: '📝' }
      ],
      navLink: 'planning',
      navLabel: 'Voir planning'
    }
  };

  const config = roleConfigs[role] || {
    icon: '📋',
    title: `Espace ${role}`,
    description: 'Fonctionnalités à venir',
    items: items,
    navLink: 'planning',
    navLabel: 'Voir planning'
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <span style={styles.headerIcon}>{config.icon}</span>
        <div>
          <h3 style={styles.title}>{config.title}</h3>
          <p style={styles.description}>{config.description}</p>
        </div>
      </div>

      <div style={styles.itemsList}>
        {config.items.map((item, index) => (
          <div key={index} style={styles.item}>
            <span style={styles.itemIcon}>{item.icon}</span>
            <span style={styles.itemLabel}>{item.label}</span>
            <span style={styles.itemStatus}>{item.status}</span>
          </div>
        ))}
      </div>

      <div style={styles.footer}>
        <span style={styles.infoBadge}>
          Widgets métier en cours de définition
        </span>
        <button
          style={styles.navButton}
          onClick={() => onNavigate && onNavigate(config.navLink)}
        >
          {config.navLabel} →
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: 'white',
    borderRadius: '12px',
    padding: '24px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    border: '1px solid #e9ecef'
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '16px',
    marginBottom: '20px',
    paddingBottom: '16px',
    borderBottom: '1px solid #e9ecef'
  },
  headerIcon: {
    fontSize: '2.5rem'
  },
  title: {
    margin: '0 0 4px 0',
    fontSize: '1.3rem',
    fontWeight: '600',
    color: '#1a1a2e'
  },
  description: {
    margin: 0,
    fontSize: '0.95rem',
    color: '#6c757d'
  },
  itemsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    marginBottom: '20px'
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px 16px',
    backgroundColor: '#f8f9fa',
    borderRadius: '8px',
    border: '1px dashed #dee2e6'
  },
  itemIcon: {
    fontSize: '1.2rem'
  },
  itemLabel: {
    flex: 1,
    fontSize: '0.95rem',
    color: '#1a1a2e'
  },
  itemStatus: {
    fontSize: '0.8rem',
    padding: '4px 10px',
    backgroundColor: '#e9ecef',
    borderRadius: '12px',
    color: '#6c757d',
    fontWeight: '500'
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: '16px',
    borderTop: '1px solid #e9ecef'
  },
  infoBadge: {
    fontSize: '0.85rem',
    color: '#6c757d',
    fontStyle: 'italic'
  },
  navButton: {
    padding: '8px 16px',
    backgroundColor: '#6366f1',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '0.9rem',
    fontWeight: '500',
    transition: 'background-color 0.2s'
  }
};

export default BusinessPlaceholder;
